import { Box, Container, Typography } from "@mui/material";
import { LinkWithScroll } from "common/components/LinkWithScroll";
import { LanguageContext } from "configuration/app-context-manager/LanguageContext";
import React, { useContext } from "react";

export const Banner = ({ data }) => {
  const { language } = useContext(LanguageContext);

  if (data.hasImage) {
    return (
      <LinkWithScroll to={`/${language}/region`} style={{ textDecoration: "none" }}>
        <Box
          sx={{
            position: "relative",
            overflow: "hidden",
            minHeight: { xs: "280px", md: "350px" },
            cursor: "pointer",
            "&:hover .banner-img": {
              transform: "scale(1.04)",
            },
          }}
        >
          {/* Background image */}
          <Box
            className="banner-img"
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundImage: `url(${require(`assets/images/${data.image}`)})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundAttachment: { md: "fixed", xs: "scroll" },
              transition: "transform 0.8s ease",
            }}
          />
          {/* Dark overlay */}
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background:
                "linear-gradient(to bottom, rgba(33,3,6,0.45) 0%, rgba(33,3,6,0.35) 100%)",
            }}
          />
          {/* Content */}
          <Box
            sx={{
              position: "relative",
              zIndex: 1,
              minHeight: { xs: "280px", md: "350px" },
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Container maxWidth="md" sx={{ textAlign: "center" }}>
              <Typography
                color="secondary"
                sx={{
                  fontFamily: "'Cormorant Garamond', serif",
                  fontWeight: 400,
                  fontSize: { xs: "1.5rem", md: "2rem" },
                  letterSpacing: "0.1em",
                  mb: 2,
                  textShadow: "0 2px 10px rgba(0,0,0,0.3)",
                }}
              >
                {data.title}
              </Typography>
              <Box
                sx={{
                  width: 50,
                  height: "1px",
                  background: "var(--clr-primary-light)",
                  mx: "auto",
                  mb: 2,
                }}
              />
              <Typography
                variant="body1"
                color="secondary"
                sx={{
                  fontSize: { xs: "0.85rem", md: "0.95rem" },
                  letterSpacing: "0.05em",
                  opacity: 0.9,
                }}
              >
                {data.text}
              </Typography>
            </Container>
          </Box>
        </Box>
      </LinkWithScroll>
    );
  }

  // Text-only banner
  return (
    <Box
      sx={{
        background: "linear-gradient(135deg, #c0a661 0%, #a08941 50%, #c0a661 100%)",
        py: { xs: 6, md: 8 },
      }}
    >
      <Container maxWidth="md" sx={{ textAlign: "center" }}>
        <Typography
          color="secondary"
          sx={{
            fontFamily: "'Cormorant Garamond', serif",
            fontWeight: 400,
            fontSize: { xs: "1.5rem", md: "2rem" },
            letterSpacing: "0.08em",
            mb: 2,
          }}
        >
          {data.title}
        </Typography>
        <Box
          sx={{
            width: 50,
            height: "1px",
            background: "rgba(245,245,245,0.5)",
            mx: "auto",
            mb: 2.5,
          }}
        />
        <Typography
          variant="body1"
          color="secondary"
          sx={{
            lineHeight: 1.9,
            fontSize: { xs: "0.9rem", md: "0.95rem" },
            opacity: 0.95,
          }}
        >
          {data.text}
        </Typography>
      </Container>
    </Box>
  );
};
